import { Icon, IconProps } from './Icon';

export const LanguageIcon = ({ color = 'currentColor', ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      d="M4 5.35294H12.3125M9.9375 3V5.35294C9.9375 10.5506 7.27869 14.7647 4 14.7647"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5.1875 10.0586C5.1875 12.5809 8.693 14.6562 13.1437 14.7645M13.5 22.9998L18.25 12.4115L23 22.9998M21.9313 20.6468H14.5687"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
